import AgreementDetail from './agreement-detail';
import TemplatesList from './template-lists'
import Wrapper from './wrapper/ContractSideMenuWrapper'

export default { AgreementDetail, TemplatesList, Wrapper };
